'use client';
import Image, { StaticImageData } from 'next/image';
import { useMedia } from '@ssv-website/hooks';
import Link from 'next/link';
import { Logo } from '../logo';
import public_account from './images/public-account.png';
import video_code from './images/video-number.png';
import logo_icon from './images/footer-logo.png';
import wechat_logo from './images/wechat-logo.png';
import wechat_code from './images/wechat-code.png';
import footerList, { getBg, getColor, Theme } from './preset';
import wechat_logo_dark from './images/wechat-icon-dark.svg';
import wechat_code_bg from './images/wechat-code-bg.png';
import SSVLink from '../ssv-link';

export const Footer = (props: { theme?: Theme; className?: string }) => {
  const { theme = 'white', className = '' } = props;
  const isMobile = useMedia('mobile');
  const bg = getBg(isMobile, theme);
  const color = getColor(theme);
  return (
    <div
      id="Footer"
      className={`w-full flex justify-center bg-no-repeat bg-cover ${className}`}
      style={{
        backgroundImage: `url(${bg.src})`,
        backgroundPosition: !isMobile ? '60% 0' : '0 30%',
        color: color ?? '#353f49',
        borderTop: theme === 'white' ? '1px solid #dcdcdc' : undefined,
      }}
    >
      <div className="max-w-5xl flex flex-col w-full desktop:px-5">
        <div className="flex justify-between items-center desktop:pr-5">
          <Logo
            className="w-[160px] h-[38px] mobile:hidden mt-9"
            src={theme === 'blue' ? logo_icon : undefined}
          />

          <div className="group relative mobile:hidden">
            <Image
              src={theme === 'white' ? wechat_logo_dark : wechat_logo}
              alt=""
              className="w-6 h-6 object-contain cursor-pointer"
            />
            <div
              className="absolute z-50 right-1/2 translate-x-1/2 bottom-[28px] w-[120px] p-0 overflow-hidden h-0 group-hover:h-[124px] bg-contain group-hover:p-[4px] desktop:right-[100%]"
              style={{
                backgroundImage: `url(${
                  (wechat_code_bg as unknown as StaticImageData).src
                })`,
              }}
            >
              <Image src={wechat_code} alt="" className="w-full object-cover" />
            </div>
          </div>
        </div>
        <div className="flex justify-between gap-20 desktop:gap-10 mt-20 mobile:flex-col-reverse mobile:mt-16 mobile:gap-9">
          <FooterList isMobile={isMobile} />
          <DimensionalCode />
        </div>
        <FootNote />
      </div>
    </div>
  );
};

const FooterList = (props: { isMobile: boolean }) => {
  const { isMobile } = props;
  const list = isMobile ? footerList.slice(1) : footerList;

  return (
    <div className="flex justify-between flex-1 mobile:justify-evenly">
      {list.map((item, index) => (
        <div key={index}>
          <div className={`font-600 text-base mb-5 mobile:text-sm mobile:mb-3`}>
            {item.title}
          </div>
          {item.list.map((v, i) => (
            <SSVLink url={v.path} key={v.text + i}>
              <div
                className={`font-400 opacity-80 cursor-pointer text-base leading-none mb-5 hover:opacity-100 hover:font-500 mobile:text-sm mobile:mb-3 `}
              >
                {v.text}
              </div>
            </SSVLink>
          ))}
        </div>
      ))}
    </div>
  );
};
const DimensionalCode = () => {
  return (
    <div className="flex gap-2 justify-center">
      <div className="font-400">
        <Image src={video_code} alt="" className={`object-cover w-32 h-32`} />
        <div className={`text-center opacity-40 mt-1 text-sm`}>
          关注官方视频号
        </div>
      </div>
      <div className="font-400">
        <Image
          src={public_account}
          alt=""
          className={`object-cover w-32 h-32`}
        />
        <div className={`text-center opacity-40 mt-1 text-sm`}>
          关注官方公众号
        </div>
      </div>
    </div>
  );
};
const FootNote = () => {
  return (
    <div
      className={`opacity-40 w-full text-base mobile:text-xss mb-5 mt-16 mobile:mt-12 mobile:mb-5 mobile:text-center`}
    >
      Copyright © 1998 - 2025 Tencent. All Rights Reserved.
    </div>
  );
};
